import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SearchContainer from '../../components/SearchContainer';
import ServicesSection from '../../components/ServicesSection';
import { getActiveServices } from '../../api/services';
import '../../css/main.css';
import Banner from '../../components/Banner';
import CitySearch from '../../components/CitySearch';
import RecommendationSlides from './RecommendationSlides';
import SignIn from './SignIn';
import PackageDeal from './PackageDeal';
import FavoriteStay from './FavoriteStay';
import BerMonths from './BerMonths';
import ExploreStays from './ExploreStays';

export default function Main() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('stay');
  const [bookingServices, setBookingServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServices();
  }, []);

    const fetchServices = async () => {
      try {
        setLoading(true);
        const response = await getActiveServices();
        if (response.success) {
          setBookingServices(response.data);
        }
      } catch (err) {
        console.error('Error fetching services:', err);
        // Optionally, still set loading to false or show fallback UI
      } finally {
        setLoading(false);
      }
    };

  const handleSearch = ({ region, query }) => {
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };


  const handleServiceSelect = (service) => {
    navigate('/booking', { 
      state: { 
        selectedServiceId: service._id || service.id,
        serviceTitle: service.title
      } 
    });
  };

  // Transform API data to match expected format - don't filter here, just transform
  const allTransformedServices = bookingServices
    .map(service => ({
      id: service._id,
      _id: service._id,
      title: service.title,
      category: service.category,
      image: service.image,
      rating: service.rating,
      reviews: service.reviews,
      price: service.price,
      minPax: service.minPax,
      description: service.description,
      features: service.features,
      recommended: service.recommended,
      bestPrice: service.bestPrice,
      order: service.order || 0,
      createdAt: service.createdAt
    }))
    .sort((a, b) => {
      // Sort by order field (set by admin), then by creation date as fallback
      const orderA = a.order || 0;
      const orderB = b.order || 0;
      
      if (orderA === orderB) {
        // Fallback to creation date if order is the same
        return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
      }
      
      return orderA - orderB;
    });

  // Filter services for display based on activeTab - this is only for UI display
  const filteredServicesForDisplay = allTransformedServices.filter(service => {
    if (activeTab === 'stay') {
      return service.category === 'stay';
    } else if (activeTab === 'experience') {
      return service.category === 'experience';
    } else if (activeTab === 'event') {
      return service.category === 'event'; // Show all event services like other tabs
    }
    return true; // Show all if no specific tab
  });

  // Final services to display: just use filtered services (no special event search behavior)
  const servicesToDisplay = filteredServicesForDisplay;

  return (
    <div className="main-container">

      <Banner />

      <CitySearch 
        onSearch={handleSearch} 
        activeTab={activeTab}
        onTabChange={handleTabChange}
        allServices={allTransformedServices}
      />

        {loading ? (
          <div className="services-loading">
            <div className="loading-spinner"></div>
            <p>Loading services...</p>
          </div>
        ) : (
        <>
        {servicesToDisplay.length > 0 ? (
          <ServicesSection 
            services={servicesToDisplay} 
            onServiceSelect={handleServiceSelect}
            activeTab={activeTab}
          />
        ) : (
          <>
            {/* <SignIn /> */}
            <PackageDeal />
            <RecommendationSlides />
            <ExploreStays />
            {/* <FavoriteStay /> */}
            <BerMonths />
            
          </>
        )}
        </>
      )}
    </div>
  );
}